import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSelectionList, MatInput, MatDialog } from '@angular/material';

@Component({
  selector: 'app-choose-action',
  templateUrl: './choose-action.component.html',
  styleUrls: ['./choose-action.component.scss']
})
export class ChooseActionComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ChooseActionComponent>,
  ) { }

  ngOnInit() {
  }

  assignAgency() {
    this.dialogRef.close({result: 'agencyClicked'});
  }

  assignInspector() {
    this.dialogRef.close({result: 'inspectorClicked'});
  }

  closeClicked() {
    this.dialogRef.close({result: 'cancelled'});
  }

}
